module.exports = __webpack_public_path__ + "static/img/other_FAQ_pic06.ed6f6ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other_FAQ/other_FAQ_pic06.png
// module id = 558
// module chunks = 1